// Centralized Account Type definitions for Leads and Clients
export const ACCOUNT_TYPES = [
  // Commercial Office Building
  { value: "corporate-office", label: "Corporate Office" },
  { value: "professional-service", label: "Professional Service Firm" },
  { value: "co-working", label: "Co-working Space" },
  { value: "business-park", label: "Business Park" },
  { value: "office-complex", label: "Office Complex" },

  // Educational Institution
  { value: "k-12", label: "K-12 School" },
  { value: "university", label: "University or College" },
  { value: "private-academy", label: "Private Academy" },
  { value: "vocational-school", label: "Vocational School" },
  { value: "daycare", label: "Daycare Center" },

  // Healthcare Facility
  { value: "hospital", label: "Hospital" },
  { value: "medical-clinic", label: "Medical Clinic" },
  { value: "dental-office", label: "Dental Office" },
  { value: "surgery-center", label: "Outpatient Surgery Center" },
  { value: "physical-therapy", label: "Physical Therapy Center" },
  { value: "long-term-care", label: "Long-term Care Facility" },

  // Retail Space
  { value: "shopping-mall", label: "Shopping Mall" },
  { value: "department-store", label: "Department Store" },
  { value: "boutique", label: "Boutique" },
  { value: "grocery-store", label: "Grocery Store" },
  { value: "big-box", label: "Big Box Retailer" },

  // Hospitality Industry
  { value: "hotel", label: "Hotel or Motel" },
  { value: "resort", label: "Resort" },
  { value: "convention-center", label: "Convention Center" },
  { value: "banquet-hall", label: "Banquet Hall" },
  { value: "restaurant", label: "Restaurant or Cafe" },

  // Financial Institution
  { value: "bank", label: "Bank" },
  { value: "credit-union", label: "Credit Union" },
  { value: "investment-firm", label: "Investment Firm" },
  { value: "insurance-company", label: "Insurance Company" },

  // Industrial Facility
  { value: "manufacturing", label: "Manufacturing Plant" },
  { value: "warehouse", label: "Warehouse" },
  { value: "distribution-center", label: "Distribution Center" },
  { value: "food-processing", label: "Food Processing Facility" },
  { value: "factory", label: "Factory" },

  // Religious Facility
  { value: "church", label: "Church" },
  { value: "synagogue", label: "Synagogue" },
  { value: "mosque", label: "Mosque" },
  { value: "religious-education", label: "Religious Education Center" },

  // Government Building
  { value: "municipal-office", label: "Municipal Office" },
  { value: "courthouse", label: "Courthouse" },
  { value: "post-office", label: "Post Office" },
  { value: "dmv", label: "DMV Location" },
  { value: "public-library", label: "Public Library" },

  // Entertainment Venue
  { value: "movie-theater", label: "Movie Theater" },
  { value: "concert-hall", label: "Concert Hall" },
  { value: "sports-arena", label: "Sports Arena" },
  { value: "museum", label: "Museum" },
  { value: "art-gallery", label: "Art Gallery" },

  // Transportation Hub
  { value: "airport", label: "Airport" },
  { value: "bus-terminal", label: "Bus Terminal" },
  { value: "train-station", label: "Train Station" },
  { value: "subway-station", label: "Subway Station" },

  // Residential Property
  { value: "apartment-complex", label: "Apartment Complex" },
  { value: "condominium", label: "Condominium" },
  { value: "homeowners-association", label: "Homeowners Association" },
] as const;

export type AccountTypeValue = (typeof ACCOUNT_TYPES)[number]["value"];

/**
 * Format account type slug into a human-friendly label
 */
export function formatAccountType(type: string | undefined): string {
  if (!type) return "N/A";
  const found = ACCOUNT_TYPES.find(
    (t) => t.value.toLowerCase() === type.toLowerCase() || t.label.toLowerCase() === type.toLowerCase()
  );
  if (found) return found.label;

  // Fallback: title-case dashed string
  return type
    .split(/[-_]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
